import { render, staticRenderFns } from "./pricingPrices.vue?vue&type=template&id=255aab03&scoped=true&"
import script from "./pricingPrices.vue?vue&type=script&lang=js&"
export * from "./pricingPrices.vue?vue&type=script&lang=js&"
import style0 from "./pricingPrices.vue?vue&type=style&index=0&id=255aab03&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255aab03",
  null
  
)

export default component.exports